/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import logoIcon from '../../assets/images/logoBig.png';
import questionSignIcon from '../../assets/images/questionSign.png';
import ProjectListDropDown from '../ProjectListDropDown/ProjectListDropDown';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { usePaths } from 'hooks/usePaths';
import { getPlotThunk } from 'store/explore/thunk';
import { getAllWorkspacesThunk } from 'store/workspace/thunk';
import { revokeToken } from 'api/auth/service';
import settingsIcon from 'assets/icons/settings.svg';
import userSettingsIcon from 'assets/icons/user.svg';
import PopUpDropDown from '../PopUpDropDown/PopUpDropDown';
import { ProjectsNavbar } from './Porjects';
import './navbar.scss';
import { mapViewSlice } from "store/mapView/slice";
import { USER_ROLES } from 'helpers/constants/commons';
import { filterDataByRole } from 'helpers/functions/commons';
import { getActiveUser } from 'helpers/auth';
import { filteredDataWindowThunk } from 'store/footer/thunk';
import { selectSelectedTab, workspaceSlice } from 'store/workspace/slice';
import { selectAllTagAttributes } from 'store/sidebar/selectors';
import { selectIsDatasetChanged } from 'store/userData/selectors';
import { trackGAEvent } from 'helpers/functions/GoogleAnalytics/GA';
import { clickEventsGA, eventsGA } from 'helpers/functions/GoogleAnalytics/types';
import { selectActiveUser } from 'store/userState/selectors';
import { useJoyrideContext } from 'contexts/JoyrideContext';

const navBarLinks = [
    {
        name: 'Home',
        link: '/home',
        tooltip: 'Access the Workspace Management, Notifications and Community Section',
        roles: Object.values(USER_ROLES)
    },
    {
        name: 'Data',
        link: '/data',
        tooltip: 'Import, Edit, Export, and Share your User Datasets',
        roles: Object.values(USER_ROLES)
    },
    {
        name: 'Explore',
        link: '/Explore',
        tooltip: 'Visualise and interrogate data',
        roles: Object.values(USER_ROLES)
    },
    {
        name: 'Subscriptions',
        link: '/projects',
        tooltip: 'Workflow based modules for specific Energy projects',
        roles: Object.values(USER_ROLES)
    },
    {
        name: 'Learn',
        tooltip: 'Access the knowledge base, get support, or suggest a feature (opens in a new tab)',
        link: 'https://belltreegroup.atlassian.net/servicedesk/customer/portals',
        external: true,
        roles: Object.values(USER_ROLES)
    },
]

const popupDropdownValues = [
    {
        name: 'Admin Section',
        url: '/Admin',
        roles: [USER_ROLES.admin, USER_ROLES.client]
    },
    {
        name: 'Change Password',
        url: '/changePassword',
        roles: Object.values(USER_ROLES)
    },
    {
        name: 'Change Authentication Method',
        url: '/changeAuthMethod',
        roles: Object.values(USER_ROLES)
    },
]

export default function Navbar() {
    const paths = usePaths()

    const generateClassName = (isActive: boolean, link: typeof navBarLinks[number]['link']) => {
        if (isActive && link !== '/projects') return 'active'
        if (paths.includes(link.substring(1))) return 'active-child'
        return ''
    }
    const activeUser = getActiveUser()
    const user = useAppSelector(selectActiveUser)
    const { isFetched: isFetchedMap } = useAppSelector(state => state.mapViewSlice);
    const { workspaces, workspaceId, deletePlot, plotId, tabs, workspaceListLoading, styleSettings } = useAppSelector(state => state.workspaceSlice)
    const isDatasetChanged = useAppSelector(selectIsDatasetChanged)
    const currentWorkspace = workspaces.find(item => item.id === workspaceId)
    const tagAttributes = useAppSelector(selectAllTagAttributes)
    const dispatch = useAppDispatch();
    const initialized = useRef(false)
    const [hoverItem, setHoverItem] = useState(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (tagAttributes?.length && !initialized?.current) {
            initialized.current = true
            dispatch(getAllWorkspacesThunk({ allTags: tagAttributes }));
        }
    }, [tagAttributes])

    useEffect(() => {
        const disabledSidebarPages = ['data', 'home', 'learn']
        dispatch(workspaceSlice.actions.hideSidebar(disabledSidebarPages.includes(paths[0])))
    }, [paths])

    const selectedTab = useAppSelector(selectSelectedTab)

    const timeoutId = useRef<any>(null)

    useEffect(() => {
        const getPlot = async () => {
            // define a thunk for this or use the one in explore page and pass the filters
            await dispatch(getPlotThunk({ plotId: selectedTab?.id || plotId, workspaceId }));
        }
        if (!workspaceListLoading && (!deletePlot && selectedTab?.type === 1 && selectedTab?.id) || isDatasetChanged){
            if(timeoutId.current) clearTimeout(timeoutId.current)
            timeoutId.current = setTimeout(() => {
                    getPlot();
                }, 600)
            }
    }, [tabs, currentWorkspace?.datasetIds, isDatasetChanged, selectedTab?.type, plotId, workspaceListLoading])

    useEffect(() => {
        if (isFetchedMap) {
            dispatch(mapViewSlice.actions.changeIsFetchedStatus(false))
        }
    }, [currentWorkspace?.datasetIds])

    useEffect(() => {
        const getFilteredDataWindow = async () => {
            await dispatch(filteredDataWindowThunk(workspaceId));
        }
        if (!workspaceListLoading && workspaceId)
            getFilteredDataWindow()
    }, [workspaceListLoading, workspaceId])

    const role = getActiveUser()?.role

    const handleClick = (value: string) => {
        if(value === "Learn") {
            trackGAEvent(eventsGA.click, clickEventsGA.learn);
        }
    };

    const topComponent = <div className='container' >
        <img src={userSettingsIcon} className='userLogo' />
        <div>
            <div className='name' > {user.name}  <span className='client' >({activeUser?.clientName})</span> </div>
            <div className='email' > {activeUser?.email} </div>

        </div>
    </div>

    const handleMouseEnter = (itemName: any) => {
        setHoverItem(itemName);
    };
    
    const handleMouseLeave = () => {
        setHoverItem(null);
    };
  
    const handleGoToQuestion = () => {
         window.open('https://belltreegroup.atlassian.net/servicedesk/customer/portal/2', '_blank', 'noopener,noreferrer');
    }
    
    const { isJoyrideAvailable, restartTour } = useJoyrideContext();

    const handleRestartTour = () => {
        if (isJoyrideAvailable && restartTour) {
            restartTour();
        }
    };
    
    const shouldShowActiveWorkspace = !['home', 'data'].includes(paths[0])

    return (
        <nav className='main-nav'>
            <ul className='nav-items'>
                <li className='logo'>
                    <img src={logoIcon} alt="bMark Logo" />
                </li>
                <div className='nav-items-container'>
                    {navBarLinks.map(i => {
                        return (
                            i.external ? (
                                <div 
                                    key={i.name} 
                                    title={i.tooltip} 
                                    className='single-nav'
                                    onClick={() => handleClick(i.name)}
                                >
                                    <a href={i.link} key={i.name} rel="noreferrer" target='_blank'>
                                        {i.name}
                                    </a>
                                    </div>
                                ) : (
                                    <div 
                                        key={i.name} 
                                        title={i.tooltip} 
                                        className='single-nav'
                                        onMouseEnter={() => handleMouseEnter(i.name)} 
                                        ref={i.name === 'Subscriptions' ? dropdownRef : null}
                                    >
                                        <NavLink
                                            to={i.link}
                                            className={({ isActive }) => generateClassName(isActive, i.link)}
                                            end
                                        >
                                            {i.name}
                                        </NavLink>
                                        {
                                            i.name === 'Subscriptions' && hoverItem === 'Subscriptions' && (
                                            <div 
                                                className="subscription-dropdown"
                                                onMouseEnter={() => handleMouseEnter('Subscriptions')}
                                                onMouseLeave={handleMouseLeave}
                                                onClick={(e) => {
                                                    // Prevent the click from bubbling to parent elements
                                                    e.stopPropagation();
                                                }}
                                            >
                                                <ProjectsNavbar />
                                            </div>
                                            )
                                        }
                                    
                                    </div>
                            )
                        );
                    })}
                </div>
            </ul>
            <ul className='nav-items-user'>
                {shouldShowActiveWorkspace && (
                    <li className="active-project">
                        <span className='active-project-label'>Active Workspace</span>
                        <div title='Switch to another workspace'>
                            <ProjectListDropDown width='200px' workspaces={workspaces} />
                        </div>
                    </li>
                )}
                <li title='Administration & Password Management'>
                    <PopUpDropDown
                        name='settings'
                        icon={settingsIcon}
                        links={filterDataByRole(popupDropdownValues, role as string)}
                    />
                </li>
                <li title={isJoyrideAvailable ? 'Restart Tour Guide' : 'No tour available on this page'} className='question'>
                    <img 
                        className={`questionIcon ${!isJoyrideAvailable ? 'disabled' : ''}`}
                        src={questionSignIcon} 
                        alt="Tour Guide" 
                        onClick={handleRestartTour}
                        style={{ 
                            cursor: isJoyrideAvailable ? 'pointer' : 'not-allowed',
                        }}
                    />
                </li>
                <li title={`Logged in as: ${activeUser?.email}`}>
                    <PopUpDropDown
                        topComponent={topComponent}
                        name='userSettings'
                        icon={userSettingsIcon}
                        links={[
                            {
                                name: 'Log Out',
                                icon: 'k-i-logout',
                                url: '/signIn',
                                callback: async () => {
                                    localStorage.clear();
                                    await revokeToken();
                                    // TODO replace this to refresh redux store on signout
                                    window.location.reload()

                                }
                            }
                        ]}
                    />
                </li>
            </ul>
        </nav>
    );
}